import React from "react";
import { NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const images = [
  require("./../../images/team.webp"),
  require("./../../images/team1.jpg"),
];

var bnr1 = require("./../../images/background/line.png");

class About4 extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/masonary.js");
  }

  render() {
    const options = {
      loop: true,
      autoplay: true,
      autoplayTimeout: 3000,
      margin: 30,
      nav: false,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      items: 1,
      dots: true,
    };
    return (
      <>
        <div className="section-full p-t80 p-b80 bg-white inner-page-padding">
          <div className="container">
            <div className="section-content ">
              <div className="row">
                <div className="col-lg-5 col-md-5 ">
                  <div className="m-about ">
                    <OwlCarousel
                      className="owl-carousel about-us-carousel"
                      {...options}
                    >
                      {images.map((item, index) => (
                        <div className="item" key={index}>
                          <div className="ow-img">
                            <NavLink to="/about">
                              <img src={item} alt="" />
                            </NavLink>
                          </div>
                        </div>
                      ))}
                    </OwlCarousel>
                  </div>
                </div>
                <div className="col-lg-7 col-md-7">
                  <div className="m-about-containt text-black ">
                    <div
                      className="m-about-years bg-moving"
                      style={{ backgroundImage: "url(" + bnr1 + ")" }}
                    >
                      <span className="text-primary large-title">30+</span>
                      <span className="large-title-info">
                        Years of Experience
                      </span>
                    </div>
                    <h3 className="font-weight-600">
                      About Build Infra & Machiwal Group
                    </h3>
                    <p className="m-b20 text-justify">
                      Build infra B2B e-commerce procurement platform focused on
                      raw materials for construction, manufacturing, and
                      infrastructure industries. It aims to modernize
                      traditional procurement processes by leveraging artificial
                      intelligence and digital supply chain solutions. The
                      platform provides a transparent and reliable marketplace
                      where businesses can source raw materials at competitive
                      prices, reducing costs and simplifying procurement
                      operations.
                    </p>
                    <p className="m-b20 text-justify">
                      Build infra emphasizes affordability, speed, and
                      scalability, positioning itself as India’s go-to solution
                      for solving sourcing challenges in the construction
                      ecosystem it is building one of India’s largest networks
                      for raw material procurement. Its offerings include
                      digital ordering, storage solutions, and procurement
                      analytics, enabling businesses to streamline supply chains
                      and improve efficiency. it is to create a fully digital,
                      efficient, and transparent procurement ecosystem,
                      fostering sustainable growth for both large enterprises
                      and Construction sites.
                    </p>

                    <div className="business-sections m-b30"></div>

                    <div className="our-advantages m-b30">
                      <h5 className="font-weight-600 m-b15 text-primary">
                        Our Key Advantages:
                      </h5>
                      <ul className="list-unstyled">
                        <li className="m-b8 d-flex align-items-center">
                          <i
                            className="fa fa-check-circle text-success m-r10"
                            style={{ fontSize: "16px" }}
                          ></i>
                          <span>Aggressive & vigorous marketing team</span>
                        </li>
                        <li className="m-b8 d-flex align-items-center">
                          <i
                            className="fa fa-check-circle text-success m-r10"
                            style={{ fontSize: "16px" }}
                          ></i>
                          <span>
                            Own warehouses/godowns at various Jaipur locations
                          </span>
                        </li>
                        <li className="m-b8 d-flex align-items-center">
                          <i
                            className="fa fa-check-circle text-success m-r10"
                            style={{ fontSize: "16px" }}
                          ></i>
                          <span>Dedicated Back Office Accounting Team</span>
                        </li>
                        <li className="m-b8 d-flex align-items-center">
                          <i
                            className="fa fa-check-circle text-success m-r10"
                            style={{ fontSize: "16px" }}
                          ></i>
                          <span>
                            Own Commercial Vehicles for local delivery
                          </span>
                        </li>
                        <li className="m-b8 d-flex align-items-center">
                          <i
                            className="fa fa-check-circle text-success m-r10"
                            style={{ fontSize: "16px" }}
                          ></i>
                          <span>Strong capital base for market investment</span>
                        </li>
                      </ul>
                    </div>

                    <div className="author-info p-t20">
                      <div className="author-name">
                        <h4 className="m-t0">Machiwal Group</h4>
                        <p>Leading Building Material Distributor</p>
                      </div>
                      <NavLink
                        to="/contactus"
                        className="site-button btn-effect m-b15"
                      >
                        <span>Get in touch</span>
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default About4;
